(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pnp-limiter-install"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle',event=>{
  const details=event.target;
  if(details.matches?.('.pnp-limiter-install, .pnp-limiter-install__tutorial')&&!details.open){
    details.querySelectorAll('video').forEach(video=>video.pause());
  }
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnp-mobile-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('pnp-mobile-purchase')) return;
  class PnpMobilePurchase extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      try { this.config = JSON.parse(this.querySelector('[data-mobile-purchase-config]').textContent); }
      catch (_) { return; }
      this.scope = document.querySelector('#MainContent .product__info-container');
      this.form = this.scope?.querySelector('product-form form[action*="/cart/add"]');
      this.primary = this.form?.querySelector('[name="add"]');
      if (!this.scope || !this.form || !this.primary) return;
      this.button = this.querySelector('[data-mobile-purchase]');
      this.price = this.querySelector('[data-mobile-price]');
      this.context = this.querySelector('[data-mobile-context]');
      this.reviewed = this.config.single;
      this.initialized = true;
      this.bfActive = !!window.PnpBfCampaign?.active;
      const locale = this.config.locale.includes('-') ? this.config.locale : this.config.locale + '-' + this.config.country;
      try { this.formatter = new Intl.NumberFormat(locale,{style:'currency',currency:this.config.currency,currencyDisplay:'narrowSymbol'}); }
      catch (_) { this.formatter = new Intl.NumberFormat('en',{style:'currency',currency:this.config.currency}); }
      this.onChange = event => {
        if (event.isTrusted && event.target.matches('variant-radios input, variant-selects select, pnp-product-addon input')) this.reviewed = true;
        this.schedule();
      };
      this.onClick = () => this.purchase();
      this.onState = event => { this.bfActive = !!event.detail?.active; this.schedule(); };
      this.onResize = () => this.schedule();
      this.onToggle = () => this.schedule();
      this.scope.addEventListener('change',this.onChange);
      this.button.addEventListener('click',this.onClick);
      document.addEventListener('pnp:bf-state',this.onState);
      document.addEventListener('toggle',this.onToggle,true);
      window.addEventListener('resize',this.onResize,{passive:true});
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.scope,{subtree:true,childList:true,attributes:true,attributeFilter:['value','checked','disabled','class','aria-disabled']});
      this.overlayObserver = new MutationObserver(() => this.schedule());
      document.querySelectorAll('cart-drawer, .menu-drawer-container, details-modal').forEach(node => this.overlayObserver.observe(node,{attributes:true,attributeFilter:['class','open']}));
      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => { this.primaryVisible = entries[0].isIntersecting; this.schedule(); },{threshold:0});
        this.intersection.observe(this.primary);
      }
      this.dataset.ready = 'true';
      this.update();
    }
    disconnectedCallback() {
      this.initialized = false;
      this.scope?.removeEventListener('change',this.onChange);
      this.button?.removeEventListener('click',this.onClick);
      document.removeEventListener('pnp:bf-state',this.onState);
      document.removeEventListener('toggle',this.onToggle,true);
      window.removeEventListener('resize',this.onResize);
      this.observer?.disconnect();
      this.overlayObserver?.disconnect();
      this.intersection?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
    schedule() {
      if (this.frame || !this.initialized) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; if (this.initialized) this.update(); });
    }
    selection() {
      const addon = this.scope.querySelector('pnp-product-addon');
      const selected = addon?.selectedVariant?.();
      const id = selected?.id || this.form.querySelector('[name="id"]')?.value;
      const variant = this.config.variants.find(item => String(item.id) === String(id));
      return {variant,addon,extra:!!addon?.hasAddon?.()};
    }
    update() {
      const {variant,addon,extra} = this.selection();
      const discounted = value => this.bfActive ? value - Math.floor(value * this.config.percentage / 100) : value;
      const amount = variant ? discounted(variant.price) + (extra ? discounted(addon.config.addonPrice) : 0) : null;
      const price = amount === null ? '' : this.formatter.format(amount / 100);
      if (this.price.textContent !== price) this.price.textContent = price;
      this.context.textContent = (extra ? this.config.strings.extra : this.config.strings.each) + ' · ' + this.config.currency;
      this.needsOptions = this.config.available && !this.config.single && (!this.reviewed || !variant || !variant.available);
      const busy = this.primary.classList.contains('loading') || this.primary.getAttribute('aria-disabled') === 'true';
      this.button.disabled = busy || !this.needsOptions && (!variant?.available || this.primary.disabled);
      this.button.textContent = busy ? this.config.strings.adding : this.needsOptions ? this.config.strings.choose : variant?.available ? this.config.strings.add : this.config.strings.soldOut;
      const overlay = document.querySelector('cart-drawer.active, .drawer.active, details.menu-drawer-container[open], dialog[open], details-modal details[open]');
      const keyboard = window.visualViewport && window.innerHeight - window.visualViewport.height > 150;
      this.hidden = !!this.primaryVisible || !!overlay || !!keyboard;
    }
    purchase() {
      if (this.button.disabled) return;
      if (this.needsOptions) {
        const picker = this.scope.querySelector('variant-radios, variant-selects');
        const target = picker || this.primary;
        target.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        const control = Array.from(picker?.querySelectorAll('input,select') || []).find(node => !node.disabled && !node.closest('[hidden]'));
        control?.focus({preventScroll:true});
        this.reviewed = true;
        this.schedule();
        return;
      }
      if (this.primary.disabled || this.primary.classList.contains('loading')) return;
      this.button.disabled = true;
      this.primary.click();
      this.schedule();
    }
  }
  customElements.define('pnp-mobile-purchase',PnpMobilePurchase);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnp-product-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('pnp-feedback-slider')) return;
  class PnpFeedbackSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.track = this.querySelector('[data-feedback-track]');
      this.previous = this.querySelector('[data-feedback-previous]');
      this.next = this.querySelector('[data-feedback-next]');
      this.controls = this.querySelector('[data-feedback-controls]');
      this.status = this.querySelector('[data-feedback-status]');
      if (!this.track || !this.previous || !this.next || !this.controls || !this.status) return;
      this.cards = Array.from(this.track.querySelectorAll('[data-feedback-card]'));
      this.videos = Array.from(this.track.querySelectorAll('video'));
      this.videoCards = this.cards.filter(card => card.querySelector('video'));
      this.cardVisibility = new Map(this.videoCards.map(card => [card, true]));
      this.sectionInView = true;
      this.listeners = [];
      this.updateTimer = null;
      this.initialized = true;
      this.listen(this.previous, 'click', () => this.scrollCard(-1));
      this.listen(this.next, 'click', () => this.scrollCard(1));
      this.listen(this.track, 'scroll', () => this.scheduleUpdate(), { passive: true });
      this.listen(this.track, 'keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.scrollCard(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.maximumScroll(), behavior: this.scrollBehavior() });
        }
      });
      this.listen(window, 'resize', () => this.scheduleUpdate());
      this.listen(document, 'visibilitychange', () => {
        if (document.hidden) this.pauseVideos();
      });
      this.videos.forEach(video => this.listen(video, 'play', () => {
        const card = video.closest('[data-feedback-card]');
        if (document.hidden || !this.sectionInView || this.cardVisibility.get(card) === false) {
          if (!video.paused) video.pause();
          return;
        }
        this.videos.forEach(other => { if (other !== video && !other.paused) other.pause(); });
      }));
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new window.IntersectionObserver(entries => {
          if (!this.initialized) return;
          entries.forEach(entry => {
            const visible = entry.isIntersecting && entry.intersectionRatio > 0;
            if (entry.target === this) {
              this.sectionInView = visible;
              if (!visible) this.pauseVideos();
            } else {
              this.cardVisibility.set(entry.target, visible);
              if (!visible) Array.from(entry.target.querySelectorAll('video')).forEach(video => { if (!video.paused) video.pause(); });
            }
          });
        }, { root: null, threshold: [0, 0.01] });
        this.visibilityObserver.observe(this);
        this.videoCards.forEach(card => this.visibilityObserver.observe(card));
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new window.ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.track);
      }
      this.update();
    }
    disconnectedCallback() {
      this.initialized = false;
      this.listeners?.forEach(([target, type, callback, options]) => target.removeEventListener(type, callback, options));
      this.listeners = [];
      if (this.updateTimer !== null) window.clearTimeout(this.updateTimer);
      this.updateTimer = null;
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.pauseVideos();
      if (this.controls) this.controls.hidden = true;
    }
    listen(target, type, callback, options) {
      target.addEventListener(type, callback, options);
      this.listeners.push([target, type, callback, options]);
    }
    pauseVideos() {
      this.videos?.forEach(video => { if (!video.paused) video.pause(); });
    }
    scheduleUpdate() {
      if (!this.initialized) return;
      if (this.updateTimer !== null) window.clearTimeout(this.updateTimer);
      this.updateTimer = window.setTimeout(() => {
        this.updateTimer = null;
        if (this.initialized) this.update();
      }, 80);
    }
    maximumScroll() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }
    scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    cardStep() {
      const first = this.cards[0]?.getBoundingClientRect();
      const second = this.cards[1]?.getBoundingClientRect();
      if (first && second && Math.abs(second.left - first.left) > 0) return Math.abs(second.left - first.left);
      const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      return (first?.width || this.track.clientWidth) + gap;
    }
    scrollCard(direction) {
      if (!this.initialized) return;
      this.track.scrollBy({ left: direction * this.cardStep(), behavior: this.scrollBehavior() });
    }
    update() {
      if (!this.initialized) return;
      const maximum = this.maximumScroll();
      const position = Math.max(0, Math.min(maximum, this.track.scrollLeft));
      this.previous.disabled = position <= 2;
      this.next.disabled = position >= maximum - 2;
      this.controls.hidden = this.cards.length < 2 || maximum <= 2;
      if (!this.cards.length) {
        this.status.textContent = '';
        return;
      }
      const trackRect = this.track.getBoundingClientRect();
      const left = trackRect.left + (this.track.clientLeft || 0);
      const right = left + this.track.clientWidth;
      const positions = this.cards.map(card => card.getBoundingClientRect());
      const visible = positions.map((rect, index) => ({ rect, index })).filter(({ rect }) => rect.left >= left - 1 && rect.right <= right + 1);
      let first;
      let last;
      if (visible.length) {
        first = visible[0].index + 1;
        last = visible[visible.length - 1].index + 1;
      } else {
        const center = (left + right) / 2;
        let nearest = 0;
        positions.forEach((rect, index) => {
          if (Math.abs((rect.left + rect.right) / 2 - center) < Math.abs((positions[nearest].left + positions[nearest].right) / 2 - center)) nearest = index;
        });
        first = nearest + 1;
        last = first;
      }
      const template = first === last ? this.dataset.positionSingle || '__FIRST__/__TOTAL__' : this.dataset.positionRange || '__FIRST__–__LAST__/__TOTAL__';
      const text = template.replace(/__FIRST__/g, String(first)).replace(/__LAST__/g, String(last)).replace(/__TOTAL__/g, String(this.cards.length));
      if (this.status.textContent !== text) this.status.textContent = text;
    }
  }
  customElements.define('pnp-feedback-slider', PnpFeedbackSlider);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnp-purchase-feedback"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle',event=>{
  if(event.target.matches?.('.pnp-purchase-feedback details')&&!event.target.open)event.target.querySelectorAll('video').forEach(video=>video.pause());
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnp-throttle-install"] && !Shopify.designMode) return;
  try {
    (() => {
  const openThrottleGuide = () => {
    if (window.location.hash !== '#pnp-throttle-fitting') return;
    const guide = document.getElementById('pnp-throttle-fitting');
    if (!guide) return;
    guide.open = true;
    guide.scrollIntoView({ block: 'start' });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href="#pnp-throttle-fitting"]');
    if (!link) return;
    const guide = document.getElementById('pnp-throttle-fitting');
    if (!guide) return;
    guide.open = true;
    guide.querySelector('summary')?.focus({ preventScroll: true });
    if (window.location.hash === '#pnp-throttle-fitting') guide.scrollIntoView({ block: 'start' });
  });
  window.addEventListener('hashchange', openThrottleGuide);
  openThrottleGuide();
})();
  } catch(e) { console.error(e); }
})();

})();
